/**
 * sun-sibling-badge.js
 *
 * Carte produit (sun-product-grid-item) : actualise le badge « épuisé » selon le
 * swatch sibling survolé. Par défaut le badge reflète le produit affiché (rendu
 * SSR). Quand on survole le swatch d'un sibling DISPONIBLE, on masque le badge ;
 * quand on survole un sibling épuisé, on le réaffiche ; en quittant la liste de
 * swatches, on restaure l'état par défaut.
 *
 * Additif : ne patche pas la classe `SiblingSwatches` du thème (qui swappe déjà
 * image + prix au survol). Délégation sur `document` → survit aux re-render de
 * grille (filtres, recently-viewed, infinite scroll) sans ré-init.
 *
 * Contrat markup (snippets/sun-product-grid-item.liquid) :
 *   - swatch        : `.swatch__button[data-sibling-sold-out]` ("true" | "false")
 *   - liste swatch  : `[data-sibling-inner]`
 *   - racine carte  : `.product-item`
 *
 * Limite connue : si le produit affiché est disponible (aucun badge rendu) et
 * qu'un sibling est épuisé, aucun badge n'apparaît (pas d'injection HTML en JS,
 * SSR-first). Le cas corrigé est le bug remonté : produit affiché épuisé → badge
 * qui restait collé sur tous les swatches.
 */
(function () {
  'use strict';

  const SWATCH = '.swatch__button[data-sibling-sold-out]';
  const HOLDER = '[data-sibling-inner]';
  const CARD = '.product-item';
  const AVAILABLE_CLASS = 'is-sibling-available';

  function onSwatchEnter(event) {
    const swatch = event.target.closest(SWATCH);
    if (!swatch) return;

    const card = swatch.closest(CARD);
    if (!card) return;

    const soldOut = swatch.getAttribute('data-sibling-sold-out') === 'true';
    card.classList.toggle(AVAILABLE_CLASS, !soldOut);
  }

  function onHolderLeave(event) {
    const holder = event.target.closest(HOLDER);
    if (!holder) return;

    // Ignore les mouvements internes à la liste de swatches.
    if (holder.contains(event.relatedTarget)) return;

    const card = holder.closest(CARD);
    if (card) card.classList.remove(AVAILABLE_CLASS);
  }

  document.addEventListener('mouseover', onSwatchEnter, { passive: true });
  document.addEventListener('focusin', onSwatchEnter, { passive: true });
  document.addEventListener('mouseout', onHolderLeave, { passive: true });
  document.addEventListener('focusout', onHolderLeave, { passive: true });
})();
